import React, {useState} from 'react';
import {debounce} from 'lodash';
import {CropIcon, CustomCrop, FourThree, NineSixteen, SixteenNine} from '../../../ui-components/Iconpack';
import {SubMenuProps} from './SubMenu';

export const TransformSubMenu: React.FC<SubMenuProps> = (props) => {
    const [width, setWidth] = useState<string>(props.transformationObject.width);
    const [height, setHeight] = useState<string>(props.transformationObject.height);

    const debounceDuration = 500;

    const allowPadding = () => {
        return props.transformationObject.height.length > 0 && props.transformationObject.width.length > 0;
    };

    const debouncedHandleWidthChange = debounce((value) => {
        if (value === '' || /^\d+$/.test(value)) {
            props.updateTransformationObject({...props.transformationObject, width: value});
            // onTransformValuesChange({ width: value, height, padding: false });
        }
    }, debounceDuration);

    const debouncedHandleHeightChange = debounce((value) => {
        if (value === '' || /^\d+$/.test(value)) {
            props.updateTransformationObject({...props.transformationObject, height: value});
            // onTransformValuesChange({ width, height: value, padding:false });
        }
    }, debounceDuration);

    const handlePaddingCheck = () => {
        props.updateTransformationObject({
            ...props.transformationObject,
            paddingApplied: !props.transformationObject.paddingApplied,
        });
        // onTransformValuesChange({ width, height, padding:!enablePadding });
    };

    const handleInputChange = (field: string, value: string) => {
        if (field === 'width') {
            setWidth(value);
            debouncedHandleWidthChange(value);
        } else if (field === 'height') {
            setHeight(value);
            debouncedHandleHeightChange(value);
        }
    };
    const handleArChange = (ar: number) => {
        props.updateTransformationObject({
            ...props.transformationObject,
            ar: ar,
        });
    };

    return (
        <>
            <div className='flex items-center'>
                <div className='block cursor-pointer items-center justify-center rounded-[6px] border-[2px] border-[#4E5BA6] bg-[#717BBC] p-[12px] md:mx-[16px] md:hidden'>
                    <CropIcon color='#FFFFFF' />
                </div>
                <div className='flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>TRANSFORM</span>
                </div>
            </div>
            <span className='flex flex-col gap-5 pt-6 text-[12px] font-[700] text-[#FFFFFF] md:pt-5'>Resize</span>
            <div className='mt-[7px]'>
                <div className='flex gap-[6.5px]'>
                    <input
                        type='text'
                        value={width}
                        placeholder='W: 600'
                        className='h-[45px] w-[150px] rounded-[6px] border border-[#D0D5DD] px-2 py-1 text-[12px] placeholder-[#667085] shadow placeholder:text-[12px] placeholder:font-[400] md:h-[35px] md:w-[90px]'
                        onChange={(e) => handleInputChange('width', e.target.value)}
                    />
                    <input
                        type='text'
                        placeholder='H: 600'
                        value={height}
                        className='h-[45px] w-[150px] rounded-[6px] border border-[#D0D5DD] px-2 py-1 text-[12px] placeholder-[#667085] shadow placeholder:text-[12px] placeholder:font-[400] md:h-[35px] md:w-[90px]'
                        onChange={(e) => handleInputChange('height', e.target.value)}
                    />
                </div>
                <div className='my-4 border-b border-[#667085] pb-4'>
                    <span className='text-[12px] font-[700] text-[#FFFFFF]'>Common Sizes</span>
                    <div className='mt-2 grid cursor-pointer grid-cols-4 gap-3 md:grid-cols-2'>
                        <div onClick={() => handleArChange(1)}>
                            <CustomCrop />
                        </div>
                        <div onClick={() => handleArChange(4 / 3)}>
                            <FourThree />
                        </div>
                        <div onClick={() => handleArChange(16 / 9)}>
                            <SixteenNine />
                        </div>
                        <div onClick={() => handleArChange(9 / 16)}>
                            <NineSixteen />
                        </div>
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    <input
                        type='checkbox'
                        disabled={!allowPadding()}
                        checked={props.transformationObject.paddingApplied}
                        onChange={handlePaddingCheck}
                        className='rounded-1 h-4 w-4 border border-[#D0D5DD] p-3'
                    />

                    <span className='text-[14px] font-[400] text-[#FFFFFF]'>
                        Add Padding
                        {!allowPadding() && <span className='text-[14px] font-[600]'> (disabled) </span>}
                    </span>
                </div>
            </div>
        </>
    );
};
